import styled, { css } from 'styled-components';
import { THEME } from '../../../../../../../themes';
import Tag from '../../../../../../../components/Common/tag/tag.component';
import { hexToRgbA } from '../../../../../../../utils/colors';
import { ASSETS } from '../../../../../../../assets';
import IconButton from '../../../../../../../components/Common/Buttons/icon-button/icon-button.component';

const marginTag = css<{ askedByUser: boolean }>`
  padding-left: ${({ askedByUser }) => askedByUser ? THEME.SPACING.TINY : 0};
  margin-right: ${THEME.SPACING.TINY};
  margin-bottom: ${THEME.SPACING.TINY};
  border: unset;
`;

const askedByUserStyle = css`
  background-color: ${hexToRgbA(THEME.COLORS.SECONDARY, THEME.OPACITY.GHOST)};
`;

const regularStyle = css`
  border: none;
`;

export const Container = styled.div`
  position: relative;
`;

export const ExperienceTagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ExperienceTag = styled(Tag)<{ askedByUser: boolean }>`
  ${marginTag};
  ${({ askedByUser }) => askedByUser ? askedByUserStyle : regularStyle};
`;

const iconStyle = css`
  height: 12px;
  color: ${THEME.COLORS.PRIMARY};
`;

export const SkillTagIcon = styled(ASSETS.V_SIGN)`
  ${iconStyle};
  fill: currentColor;
`;

export const IndustryTagIcon = styled(ASSETS.INSTITUTION_BUILDING)`
  ${iconStyle};
`;

export const SmallCompanyIcon = styled(ASSETS.SHIRT_S)`
  ${iconStyle};
`;

export const MediumCompanyIcon = styled(ASSETS.SHIRT_M)`
  ${iconStyle};
`;

export const LargeCompanyIcon = styled(ASSETS.SHIRT_L)`
  ${iconStyle};
`;

export const VeryLargeCompanyIcon = styled(ASSETS.SHIRT_XL)`
  ${iconStyle};
`;

export const SeeMoreButton = styled(IconButton)`
  color: ${THEME.COLORS.PRIMARY_DARK};
  background-color: transparent;
  height: fit-content;
  position: absolute;
  bottom: ${THEME.SPACING.TINY};
  right: ${`-${THEME.SPACING.TINY}`};
  opacity: ${THEME.OPACITY.LOW};
`;

export const SeeMoreButtonIcon = styled(ASSETS.THREE_DOTS)``;
